var _circle, _g, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "logo_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    fill: "#fff",
    transform: "matrix(-1 0 0 1 12 12)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "0B748C",
    d: "M11.693 0H0v24h11.692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B3954",
    d: "M11.693-.012H0v24h11.692z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 3.75,
    fill: "#F36B21",
    transform: "matrix(-1 0 0 1 20 20.25)"
  })));
};
export { SvgLogo as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8bWFzayBpZD0ibWFzazBfMTEwMV80NzI3IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPgogICAgPGNpcmNsZSByPSIxMiIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgMTIgMTIpIiBmaWxsPSJ3aGl0ZSIvPgogIDwvbWFzaz4KICA8ZyBtYXNrPSJ1cmwoI21hc2swXzExMDFfNDcyNykiPgogICAgPHJlY3Qgd2lkdGg9IjExLjY5MjMiIGhlaWdodD0iMjQiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDExLjY5MjYgMCkiIGZpbGw9IjBCNzQ4QyIvPgogICAgPHJlY3Qgd2lkdGg9IjExLjY5MjMiIGhlaWdodD0iMjQiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDExLjY5MjYgLTAuMDEyMjM3NSkiIGZpbGw9IiMwQjM5NTQKIi8+CiAgPC9nPgogICAgPGNpcmNsZSByPSIzLjc1IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAyMCAyMC4yNSkiIGZpbGw9IiNGMzZCMjEiLz4KPC9zdmc+Cg==";